import axios from "axios";

const authDev = {
    auth: {
      username: 'turnera_front_dev',
      password: '4J9R@g&5xS2N'
    }
  }

const authProd = {
    auth: {
      username: 'turnera_front_prd',
      password: '3i5O$B2$6j@h'
    }
  }

//  LOCAL DEV -> 0  ||  PAGINA DEV -> 1  ||  PROD -> 2

  const sitiado = 2;
  const sitios = ["http://localhost:3000/turnera/apiTurnera/index.php", "http://10.100.17.102/turnera/apiTurnera/index.php", "https://api-turnera.vicentelopez.gov.ar", " http://prd-mod-web13.vicentelopez.gov.ar/turnera/apiTurnera/index.php"]
  const authDinamico = (sitiado<=1 ? authDev : authProd);

// DINAMICO
const insertarTurno = async (payLoad, setCarga) => {
    setCarga(true);
    console.log(payLoad)

    const resp = await axios.post(`${sitios[sitiado]}/api/turnos/add`, payLoad, authDinamico);
    console.log(resp)
    setCarga(false);
    return (resp.data);
}

const buscarTurnos = async (datos, setCarga) => {
    setCarga(true);

    const resp = await axios.post(`${sitios[sitiado]}/api/turnos/buscaTurno/`, datos, authDinamico);
    console.log(resp.data);
    setCarga(false);
    return (resp.data);

}

const cancelarTurno = async (DNI, codigoTurno, setCarga) => {
    setCarga(true);

    const resp = await axios.post(`${sitios[sitiado]}/api/turnos/cancela/${codigoTurno}/${DNI}`, null, authDinamico);
    console.log(resp.data);
    setCarga(false);
    return (resp.data);

}




// LOCAL
// const insertarTurno = async (payLoad, setCarga) => {
//     setCarga(true);
//     console.log(payLoad)

//     const resp = await axios.post("http://localhost:3000/turnera/apiTurnera/index.php/api/turnos/add", payLoad, authDev);
//     console.log(resp)
//     setCarga(false);
//     return (resp.data);
// }

// const buscarTurnos = async (datos, setCarga) => {
//     setCarga(true);

//     const resp = await axios.post("http://localhost:3000/turnera/apiTurnera/index.php/api/turnos/buscaTurno/", datos, authDev);
//     console.log(resp.data);
//     setCarga(false);
//     return (resp.data);

// }

// const cancelarTurno = async (DNI, codigoTurno, setCarga) => {
//     setCarga(true);

//     const resp = await axios.post(`http://localhost:3000/turnera/apiTurnera/index.php/api/turnos/cancela/${codigoTurno}/${DNI}`, null, authDev);
//     console.log(resp.data);
//     setCarga(false);
//     return (resp.data);

// }



// DEV SERVER
// const insertarTurno = async (payLoad, setCarga) => {
//     setCarga(true);
//     console.log(payLoad)

//     const resp = await axios.post("http://10.100.18.213/turnera/apiTurnera/index.php/api/turnos/add", payLoad, authDev);
//     setCarga(false);
//     return (resp.data);
// }

// const buscarTurnos = async (datos, setCarga) => {
//     setCarga(true);

//     const resp = await axios.post("http://10.100.18.213/turnera/apiTurnera/index.php/api/turnos/buscaTurno/", datos, authDev);
//     console.log(resp.data);
//     setCarga(false);
//     return (resp.data);

// }

// const cancelarTurno = async (DNI, codigoTurno, setCarga) => {
//     setCarga(true);

//     const resp = await axios.post(`http://10.100.18.213/turnera/apiTurnera/index.php/api/turnos/cancela/${codigoTurno}/${DNI}`, null, authDev);
//     console.log(resp.data);
//     setCarga(false);
//     return (resp.data);

// }


// PROD
// const insertarTurno = async (payLoad, setCarga) => {
//     setCarga(true);

//     const resp = await axios.post("https://api-turnera.vicentelopez.gov.ar/api/turnos/add", payLoad);
//     setCarga(false);
//     return (resp.data);
// }

// const buscarTurnos = async (datos, setCarga) => {
//     setCarga(true);

//     const resp = await axios.post("https://api-turnera.vicentelopez.gov.ar/api/turnos/buscaTurno/", datos);
//     setCarga(false);
//     return (resp.data);

// }

// const cancelarTurno = async (DNI, codigoTurno, setCarga) => {
//     setCarga(true);

//     const resp = await axios.post(`https://api-turnera.vicentelopez.gov.ar/api/turnos/cancela/${codigoTurno}/${DNI}`, null);
//     setCarga(false);
//     return (resp.data);

// }



export {
    insertarTurno,
    buscarTurnos,
    cancelarTurno,
}